/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eating ~2260 kcal (−500) supports steady fat loss.`)
};

const es_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comer ~2260 kcal (−500) favorece una pérdida de grasa constante.`)
};

const de_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zufuhr von ~2260 kcal (−500) unterstützt einen stetigen Fettabbau.`)
};

const nl_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met ~2260 kcal (−500) eten ondersteun je gestage vetverbranding.`)
};

const fr_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consommer environ 2260 kcal (−500) favorise une perte de graisse régulière.`)
};

const it_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangiare circa 2260 kcal (−500) favorisce una perdita di grasso costante.`)
};

const pt_br2_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumir ~2260 kcal (−500) favorece uma perda de gordura constante.`)
};

const pt_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumir ~2260 kcal (−500) favorece uma perda de gordura estável.`)
};

const ja_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`約2260kcal(−500)を摂取すると着実な脂肪減少につながります。`)
};

const zh_bmr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日摄入约 2260 千卡（−500）有助于稳定减脂。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_ex3", locale)
	if (locale === "en") return en_bmr_ex3(inputs)
	if (locale === "es") return es_bmr_ex3(inputs)
	if (locale === "de") return de_bmr_ex3(inputs)
	if (locale === "nl") return nl_bmr_ex3(inputs)
	if (locale === "fr") return fr_bmr_ex3(inputs)
	if (locale === "it") return it_bmr_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_ex3(inputs)
	if (locale === "pt") return pt_bmr_ex3(inputs)
	if (locale === "ja") return ja_bmr_ex3(inputs)
	return zh_bmr_ex3(inputs)
};